export const tableschema1 = {
    name_table: 'Розділ I. Кількість дітей у закладі на кінець звітного року(Державна статистика)',
    titles:[
        "Усього",
        "у тому числі у віці до 1 року",
        "від 1 року до 2 років",
        "від 2 до 3 років",
        "3 роки і старше",
        "з них діти, яким до 1 вересня наступного за звітним року виповниться 5 років",
        "6 років",
        "7 років",
        "Із рядка 1000 – діти-сироти та діти, позбавлені батьківського піклування",
        "діти з інвалідністю",
        "діти з особливими освітніми потребами",
        "з них: в інклюзивних групах",
        "в спеціальних групах",
        "в санаторних групах",
        "в групах загального типу",
        "діти, потерпілі від наслідків Чорнобильської катастрофи",
        "діти з числа внутрішньо переміщених осіб",
        "діти учасників бойових дій",
        "діти тимчасово переведені до ЗДО",
        "діти з числа зовнішньо переміщених осіб"
      ],
    parts:[
        {title: "Кількість дітей у закладі", subtitle: "усього", fields:[
            "CHwork10001",
            "CHwork11001",
            "CHwork12001",
            "CHwork13001",
            "CHwork14001",
            "CHwork14101",
            "CHwork14201",
            "CHwork14301",
            "CHwork15001",
            "CHwork16101",
            "CHwork16201",
            "CHwork16301",
            "CHwork16401",
            "CHwork16501",
            "CHwork16601",
            "CHwork17001",
            "CHwork18001",
            "CHwork19001",
            "CHwork19101",
            "CHwork19201"
          ]
        },{title: "Кількість дітей у закладі", subtitle: "з них дівчатка", fields:[
            "CHwork10002",
            "CHwork11002",
            "CHwork12002",
            "CHwork13002",
            "CHwork14002",
            "CHwork14102",
            "CHwork14202",
            "CHwork14302",
            "CHwork15002",
            "CHwork16102",
            "CHwork16202",
            "CHwork16302",
            "CHwork16402",
            "CHwork16502",
            "CHwork16602",
            "CHwork17002",
            "CHwork18002",
            "CHwork19002",
            "CHwork19102",
            "CHwork19202"
          ]
        },{title: "Крім того, кількість дітей,охоплених соціально-педагогічним патронатом", subtitle: "", fields:[
            "CHwork10003",
            "CHwork11003",
            "CHwork12003",
            "CHwork13003",
            "CHwork14003",
            "CHwork14103",
            "CHwork14203",
            "CHwork14303",
            "CHwork15003",
            "CHwork16103",
            "CHwork16203",
            "CHwork16303",
            "CHwork16403",
            "CHwork16503",
            "CHwork16603",
            "CHwork17003",
            "CHwork18003",
            "CHwork19003",
            "CHwork19103",
            "CHwork19203"
          ]
        }
    ],
    shorts:{
        titles:[
            "1000",
            "1100",
            "1200",
            "1300",
            "1400",
            "1410",
            "1420",
            "1430",
            "1500",
            "1610",
            "1620",
            "1630",
            "1640",
            "1650",
            "1660",
            "1700",
            "1800",
            "1900",
            "1910",
            "1920"
          ],
        parts:[
            "1",
            "2",
            "3"
          ]
    }
};